
<div class="p-2 busy-overlay-parent" [ngClass]="isLoading?'disabled':''">

    <div *ngIf="isLoading || bSyncing" class="font-weight-bold busy-overlay">
      <i class="fa fa-spinner fa-spin"></i>&nbsp;Syncing Points...
    </div>

    <div *ngIf="errorMsg" class="alert alert-danger d-flex flex-row justify-content-between">
        {{errorMsg}}
        <div role="button" (click)="errorMsg=''"><i class="fa fa-times"></i></div>
    </div>

    <div *fesListView="let filteredPoints of rxPoints">
        <h5>RxDB Points</h5>
        <table>
        <tr>             
        <td>
            <div class="d-flex">
            <button class="btn btn-secondary btn-sm m-1 mr-auto" (click)="clearPoints()">Rebuild</button>
            </div>
        </td>
        <td>
            <div class="d-flex">
                <button class="btn btn-secondary btn-sm m-1 mr-auto" onclick="window.print()">Print QR Codes</button>            
            </div>
            </td>
        <td>
            <div>
            <a href="javascript:false;" (click)="loadPoints()"><i class="fas fa-sync"></i>&nbsp;Refresh</a>
            </div>
        </td>
        </tr>
        </table>

        <table class="table table-striped table-bordered table-sm">
            <thead>
                <tr>
                    <th fesSortField="_id">Point ID</th>
                    <th fesSortField="buildingId">Building ID</th>
                    <th fesSortField="public">Public</th>
                    <th fesSortField="floorAndDescript">Floor Description</th>
                    <th fesSortField="floorName">Floor Name</th>
                    <th fesSortField="locationDescription">Description</th>
                    <th fesSortField="updatedAt">updatedAt</th>
                    <th fesSortField="deleted">deleted</th>
                    <th class = "d-none" fesSortField="_rev">Revision</th>
                    <!-- <th></th> -->
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        <input fesFilterField="_id" class="small w-100" />
                    </td>
                    <td>
                        <input fesFilterField="buildingId" class="small w-100" />
                    </td>
                    <td>
                        <input fesFilterField="public" class="small w-100" />
                    </td>
                    <td>
                        <input fesFilterField="floorAndDescript" class="small w-100" />
                    </td>
                    <td>
                        <input fesFilterField="floorName" class="small w-100" />
                    </td>
                    <td>
                        <input fesFilterField="locationDescription" class="small w-100" />
                    </td>
                    <td>
                        <input fesFilterField="updatedAt" class="small w-100" />
                    </td>
                    <td>
                        <input fesFilterField="deleted" class="small w-100" />
                    </td>
                    <td class = "d-none">
                        <input fesFilterField="_rev" class="small w-100" />
                    </td>
                    <!-- <td></td> -->
                </tr>
                <tr *ngFor="let point of filteredPoints;">
                    <td>{{point._id}}
                        <!-- <p><app-point-qr-code [pointId]='point._id'></app-point-qr-code></p> -->
                    </td>                    
                    <td>{{point.buildingId}}</td>
                    <td>{{point.public}}</td>
                    <td>{{point.floorAndDescript}}</td>
                    <td>{{point.floorName}}</td>
                    <td>{{point.locationDescription}}</td>
                    <td>{{point.updatedAt|date:'yyyy-MM-dd HH:mm:ss'}}</td>
                    <td>{{point.deleted}}</td>
                    <td class="d-none">{{point._rev}}</td>
                    <!-- <td class="text-center align-middle">
                        <a class="text-nowrap" href="javascript:false;" (click)="editPoints(point)">edit</a>
                    </td> -->
                </tr>
            </tbody>
        </table>
    </div>

</div>
